<template lang="pug">
  .conversations(:class='containerClass')
    small.followAccordionWidth(v-if='searchKeyedValues("is").length > 0 && conversationsUpdateCount > 0')
      .tpadding.text-muted.text-center {{$tc('conversations.markAllAsRead.message', conversationsUpdateCount, {nb: conversationsUpdateCount})}} 
        a(@click='markAllAsRead', role='button') {{$t('conversations.markAllAsRead.button')}}
    float-btn.btn-success
      i.fa.fa-ellipsis-h
      a.btn.btn-info.clickable(@click='showAll')
        i.fa.fa-check
        .title {{$t("conversations.allConversations")}}
      a.btn.btn-warning.clickable(@click='showArchives')
        i.fa.fa-archive
        .title {{$t("conversations.archives")}}
      a.btn.btn-primary.clickable(@click='showInbox')
        i.fa.fa-inbox
        .title {{$t("conversations.inbox")}}
      a.btn.btn-success.createBtn.clickable(@click='createConversation')
        i.fa.fa-plus
        .title {{$t("conversations.createBtn")}}
    accordion.paddingBottom.mailbox(:injected="injected", container="#body", :thresold=50, ref='accordion')
      accordion-loading-header(v-if='conversationsStatus == STATUS.LOADING', @fire='doNothing') {{$t("conversations.loading")}}
      template(v-if='conversationsStatus == STATUS.LOADED')
        template(v-for='(monthAndConversations, index) in conversationsByMonth')
          accordion-subtitle(group='monthHeader')
            template(v-if='monthAndConversations.month == "today"')
              | {{ $t('events.nearly.' + monthAndConversations.month) }}
            template(v-else-if='monthAndConversations.month == "week"')
              | {{ $t('events.nearly.' + monthAndConversations.month) }}
            template(v-else)
              | {{ monthAndConversations.convs[0].lastMessageTimeFixed | unixtimeTo("MMMM YYYY") | ucfirst }}
          conversation(v-for="conversation in monthAndConversations.convs", :conversation="conversation", :injected='false', :key="conversation.eternalId", ref='conversationsRef')
        template(v-if='hasNextConversations')
          h2
          accordion-loading-header(@fire='loadNext') {{$t("conversations.loading")}}
        template(v-if='conversations.length > 0 && !hasNextConversations')
          h2 
          .information-message {{$t("conversations.allLoaded")}}
        template(v-if='conversations.length === 0 && !hasNextConversations')
          accordion-subtitle(group='monthHeader') {{$t("conversations.noConversations")}}
          .text-center
              a.btn.btn-success(@click='createConversation') {{$t("conversations.createBtn")}}
  
</template>
<script>
import FloatBtn from '@/components/shared/FloatBtn'

import Accordion from '@/components/shared/Accordion/Accordion'
import AccordionItem from '@/components/shared/Accordion/Accordion-Item'
import AccordionSubtitle from '@/components/shared/Accordion/Accordion-Subtitle'
import AccordionLoadingHeader from '@/components/shared/Accordion/Accordion-LoadingHeader'

import Conversation from './Conversation'

import STATUS from '@/utils/status'

import {mapGetters} from 'vuex'

import $ from 'jquery'
import moment from 'moment'
import _ from 'lodash'

import Proposition from '@/components/shared/Proposition'

import {unixtimeTo, ucfirst} from '@/components/shared/vue.globals'

import MousetrapManager from '@/components/shared/mousetrapManager'
// import Mark from 'mark.js'

import modalsBus from '@/components/shared/ModalsBus'
import eventsBus from '@/components/shared/EventsBus'
import {success, error} from '@/components/shared/Notify'

// window.Mark = Mark

export default {
  props: {
    convId: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      // mark: null,
      injected: false,
      STATUS: STATUS,
      loadingMore: false
    }
  },
  components: {
    FloatBtn,
    AccordionLoadingHeader,
    AccordionSubtitle,
    AccordionItem,
    Accordion,
    Conversation
  },
  created () {},
  mounted () {
    this.checkConversationPopup()
    // this.mark = new Mark('.mailbox')
    this.showInbox()
    this.scrollToStart()
    this.firstClickOnSidebar = true
    this.onSidebarClick = (data) => {
      if (this.firstClickOnSidebar === true) {
        this.firstClickOnSidebar = false
        return
      }
      this.reloadConversations()
      this.scrollToStart()
    }
    eventsBus.$on(eventsBus.CLICK_ON_SIDEBAR, this.onSidebarClick)
    MousetrapManager.bindAll({
      'k': () => {
        this.$refs.accordion.selectPreviousItem()
      },
      'j': () => {
        this.$refs.accordion.selectNextItem()
      },
      'space': () => {
        this.$refs.accordion.toggleActiveItem()
        return false
      },
      'r': () => {
        let conversationComponent = this.$refs.accordion.getActiveChildren()
        if (conversationComponent) {
          // this.$store.dispatch('conversations/markAsUnread', conversationComponent.conversation)
          conversationComponent.markAsRead()
        }
      },
      'u': () => {
        let conversationComponent = this.$refs.accordion.getActiveChildren()
        if (conversationComponent) {
          // this.$store.dispatch('conversations/markAsUnread', conversationComponent.conversation)
          conversationComponent.markAsUnread()
        }
      }
    }, 'Conversations')
  },
  destroyed () {
    this.$store.dispatch('conversations/clean', '')
    this.$store.dispatch('search/setNewText', '')
    MousetrapManager.unbindLabel('Conversations')
    eventsBus.$off(eventsBus.CLICK_ON_SIDEBAR, this.onSidebarClick)
  },
  computed: {
    ...mapGetters('groops', [
      'selectedGroops'
    ]),
    ...mapGetters('conversations', [
      'conversations',
      'conversationsStatus',
      'hasNextConversations',
      'view',
      'conversationsUpdateCount'
    ]),
    ...mapGetters('search', [
      'searchText',
      'searchObject',
      'searchOpen',
      'searchKeyedValues'
    ]),
    conversationsByMonth () {
      _.forEach(this.conversations, (conv) => {
        if (conv.lastMessageTimeFixed == null) {
          conv.lastMessageTimeFixed = conv.lastMessageTime
        }
      })
      let conversations = _.sortBy(this.conversations, (c) => 0 - c.lastMessageTimeFixed)
      let months = []
      let flatMonths = []

      _.forEach(conversations, (conversation) => {
        let m = moment.unix(conversation.lastMessageTimeFixed)
        let month = ''
        if (m.isAfter(moment().startOf('day'))) {
          month = 'today'
        } else if (m.isAfter(moment().startOf('day').subtract(1, 'week'))) {
          month = 'week'
        } else {
          month = moment.unix(conversation.lastMessageTimeFixed).format('YYYY/MM')
        }
        if (months[month] == null) {
          months[month] = {month: month, convs: []}
          flatMonths.push(months[month])
        }
        months[month].convs.push(conversation)
      })
      return flatMonths
    },
    containerClass () {
      return [this.view]
    }
  },
  methods: {
    scrollToStart () {
      this.$nextTick(() => {
        $('#body').scrollTop(0)
        $(window).trigger('scroll')
      })
    },
    reloadConversations () {
      return this.$store.dispatch('conversations/load', {groops: this.selectedGroops})
    },
    showAll () {
      this.$store.dispatch('conversations/showAll')
      this.reloadConversations()
    },
    showArchives () {
      this.$store.dispatch('conversations/showArchived')
      this.reloadConversations()
    },
    showInbox () {
      this.$store.dispatch('conversations/showInbox')
      this.reloadConversations()
    },
    createConversation (event) {
      event.stopPropagation()
      this.$store.dispatch('conversations/newConversation').then((conv) => {
        this.$nextTick(() => {
          let convComponent = _.find(this.$refs.conversationsRef, (component) => component.conversation === conv)
          if (convComponent) {
            convComponent.goToFirstFieldToEdit()
          }
        })
      })
    },
    markAllAsRead () {
      eventsBus.$emit(eventsBus.SHOW_LOADING, this._i18n.t('conversations.markAllAsRead.loading'))
      this.$store.dispatch('conversations/markAllAsRead').then(() => {
        eventsBus.$emit(eventsBus.HIDE_LOADING)
        this.$store.dispatch('conversations/setConversationsUpdateCount', 0)
        this.$synchronize.callASAP('conversationsUpdateCount')
        success(this._i18n.t('conversations.markAllAsRead.success'))
        this.$store.dispatch('search/setNewText', '')
        this.reloadConversations()
      }).catch(() => {
        eventsBus.$emit(eventsBus.HIDE_LOADING)
        error(this._i18n.t('globals.error'))
      })
    },
    doNothing () {},
    loadNext () {
      if (this.loadingMore) {
        return
      }
      this.loadingMore = true
      this.$store.dispatch('conversations/loadMore', {groops: this.selectedGroops}).then(() => {
        this.loadingMore = false
      }).catch(() => {
      })
    },
    sendSearchPropositions () {
      let searchKeys = {
        // 'to:': {
        //   storageKey: 'to',
        //   explanationKey: 'messages.to.explanation',
        //   values: () => {
        //     return new Promise((resolve, reject) => {
        //       this.$store.dispatch('contacts/load').then(() => {
        //         resolve(this.$store.getters['contacts/contacts'].map((contact) => {
        //           return { key: '"' + contact.name + '"' }
        //         }))
        //       })
        //     })
        //   }
        // },
        // 'from:': {
        //   storageKey: 'from',
        //   explanationKey: 'messages.from.explanation',
        //   values: () => {
        //     return new Promise((resolve, reject) => {
        //       this.$store.dispatch('contacts/load').then(() => {
        //         resolve(this.$store.getters['contacts/contacts'].map((contact) => {
        //           return { key: '"' + contact.name + '"' }
        //         }))
        //       })
        //     })
        //   }
        // },
        // 'on:': {
        //   storageKey: 'on',
        //   explanationKey: 'messages.on.explanation',
        //   values: [
        //     {
        //       key: 'event',
        //       explanationKey: 'messages.on.event'
        //     },
        //     {
        //       key: 'file',
        //       explanationKey: 'messages.on.file'
        //     }
        //   ]
        // },
        'is:': {
          storageKey: 'is',
          explanationKey: 'messages.is.explanation',
          values: [
            {
              key: 'read',
              explanationKey: 'messages.is.read'
            },
            {
              key: 'unread',
              explanationKey: 'messages.is.unread'
            }
          ]
        }
        // 'after:': {
        //   storageKey: 'after',
        //   nbMax: 1,
        //   explanationKey: 'messages.after.explanation'
        // },
        // 'before:': {
        //   storageKey: 'before',
        //   nbMax: 1,
        //   explanationKey: 'messages.before.explanation'
        // }
      }
      let propositions = []
      if (!this.searchOpen) {
        this.$store.dispatch('search/setPropositions', propositions)
        return
      }
      if (this.searchObject.inEntry) {
        for (let key in searchKeys) {
          if (this.searchObject.inEntry + ':' === key) {
            let data = searchKeys[key]
            let valuesPromise = data.values || []
            if (!_.isFunction(valuesPromise)) {
              valuesPromise = () => new Promise((resolve, reject) => {
                resolve(data.values || [])
              })
            }
            valuesPromise().then((values) => {
              values.forEach((value) => {
                if (this.searchObject.lastToken === key || (value.key.indexOf(this.searchObject.lastToken) === 0 && value.key !== this.searchObject.lastToken)) {
                  propositions.push(new Proposition(value.key, {
                    textToShow: key + ' ' + value.key,
                    textToRemove: this.searchObject.lastToken === key ? '' : this.searchObject.lastToken,
                    explanationKey: value.explanationKey
                  }))
                }
              })
            })
          }
        }
      } else {
        for (let key in searchKeys) {
          let data = searchKeys[key]
          if (this.searchObject.lastToken === '' || key.indexOf(this.searchObject.lastToken) === 0) {
            if (data.nbMax && this.searchObject.keys[data.storageKey] && this.searchObject.keys[data.storageKey].length >= data.nbMax) {
              continue
            }
            propositions.push(new Proposition(key, {
              textToShow: key + ' ...',
              textToRemove: this.searchObject.lastToken,
              explanationKey: searchKeys[key].explanationKey
            }))
          }
        }
      }
      this.$store.dispatch('search/setPropositions', propositions)
    },
    checkConversationPopup () {
      if (this.convId) {
        this.$store.dispatch('conversations/getConversation', this.convId).then((conv) => {
          modalsBus.open(modalsBus.modals.OPEN_SHARED_OBJECT, conv)
        }).catch(() => {
          console.error('err')
        })
      }
    }
  },
  filters: {
    unixtimeTo,
    ucfirst
  },
  watch: {
    selectedGroops (newGroops, oldGroops) {
      if (_.difference(newGroops, oldGroops, 'id').length === 0 && _.difference(oldGroops, newGroops, 'id').length === 0) {
        return
      }
      this.$store.dispatch('conversations/clean').then(() => {
        this.scrollToStart()
        this.reloadConversations()
      })
    },
    'conversations.view' () {
      this.scrollToStart()
    },
    conversations: {
      deep: true,
      handler () {
        this.$nextTick(() => {
          this.$refs.accordion.adjustFixedElements()
          // this.mark.unmark()
          // this.mark.mark(this.searchText)
        })
      }
    },
    searchText () {
      this.$store.dispatch('conversations/clean').then(() => {
        this.scrollToStart()
        this.reloadConversations()
      })
    },
    searchObject () {
      this.sendSearchPropositions()
    },
    searchOpen () {
      this.sendSearchPropositions()
    },
    $route () {
      this.checkConversationPopup()
    }
  }
}
</script>
<style lang="sass">
@import "../../assets/css/variables"
.conversations
  min-height: calc(100vh - 50px)
  &.archives
    background-color: rgba($orange, 0.3)
  &.all
    background-color: rgba($blue, 0.3)
</style>



// WEBPACK FOOTER //
// Conversations.vue?0f9d6df0